import { render, staticRenderFns } from "./SpinFontawesomeButtons.vue?vue&type=template&id=6f8cbfc4&scoped=true&"
import script from "./SpinFontawesomeButtons.vue?vue&type=script&lang=js&"
export * from "./SpinFontawesomeButtons.vue?vue&type=script&lang=js&"
import style0 from "./SpinFontawesomeButtons.vue?vue&type=style&index=0&id=6f8cbfc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8cbfc4",
  null
  
)

export default component.exports